import { ErrorNotifier } from './error_notifier';

const ALLOWED_DOMAIN_REGEXES = [
  /\.chirpbooks\.com/,
  /chirpbooks-com\.translate\.goog/,
];
const WARNING_MESSAGE_PREFIX = 'Unsupported domain proxying Chirp: ';

export const DomainChecker = {
  host() {
    return window.location.host;
  },

  checkAllowed(host) {
    if (window.chirpEnv !== 'production') {
      return true;
    }

    // host will be empty when user saves page locally (i.e. when href is 'file:///home...')
    return host === '' || ALLOWED_DOMAIN_REGEXES.some(d => d.test(host));
  },

  reportUnsupportedDomain() {
    try {
      const host = this.host();

      if (!this.checkAllowed(host)) {
        ErrorNotifier.notify(`${WARNING_MESSAGE_PREFIX}${host}`);
      }
    } catch (err) {
      ErrorNotifier.notify(err);
    }
  },
};
